import { Button, Group } from '@mantine/core';
import cx from 'clsx';

import { INTENT_TOKENS } from './intent-tokens.ts';
import classes from './StepperCard.module.css';
import type { BaseSlideProps } from '#plugin-chat/components/tools/ask-user-question/schema.ts';

export interface ConfirmationSlideProps extends BaseSlideProps {
  kind?: 'default' | 'danger' | 'info' | 'warning';
}

/** Yes/No confirmation slide with styled confirm/cancel buttons. */
export function ConfirmationSlide({ options, onOptionClick, isStreaming: _isStreaming }: ConfirmationSlideProps) {
  // Convention: first option is confirm (positive), second is cancel (negative)
  if (!options || options.length < 2) {
    return null;
  }

  const [confirmOption, cancelOption] = options;

  const confirm = INTENT_TOKENS.confirm;
  const cancel = INTENT_TOKENS.cancel;
  const ConfirmIcon = confirm.icon;
  const CancelIcon = cancel.icon;

  return (
    <Group className={classes.confirmationButtons} gap="sm">
      {cancelOption && (
        <Button
          className={cx(classes.confirmButton, classes.cancel)}
          color={cancel.color}
          leftSection={<CancelIcon size={16} />}
          onClick={() => onOptionClick([cancelOption.id])}
          variant={cancel.variant}
        >
          {cancelOption.label}
        </Button>
      )}
      {confirmOption && (
        <Button
          className={cx(classes.confirmButton, classes.confirm)}
          color={confirm.color}
          leftSection={<ConfirmIcon size={16} />}
          onClick={() => onOptionClick([confirmOption.id])}
          variant={confirm.variant}
        >
          {confirmOption.label}
        </Button>
      )}
    </Group>
  );
}
